// extracted by mini-css-extract-plugin
export default {"main__cont":"analitics_main__cont__yTCRW","button_down":"analitics_button_down__ynEu9","selobj":"analitics_selobj__zzsMx"};